import { render, staticRenderFns } from "./MonitoringManageVersion.vue?vue&type=template&id=03ca6119&scoped=true"
import script from "./MonitoringManageVersion.vue?vue&type=script&lang=js"
export * from "./MonitoringManageVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca6119",
  null
  
)

export default component.exports